import { axiosInstanceWithToken } from 'utils/axios';
import { IRoleResource, IBulkDeleteRequest, IRoleResourceWithUsers } from '../../server/types';

export const createRole = async (data: Omit<IRoleResource, 'id'>) =>
  axiosInstanceWithToken().post<IRoleResource>('roles', data);

export const updateRole = async (id: string, data: IRoleResource) =>
  axiosInstanceWithToken().put<IRoleResource>(`roles/${id}`, data);

export const fetchRoles = async () => axiosInstanceWithToken().get<IRoleResourceWithUsers[]>('roles');

export const deleteRole = async (id: string) => axiosInstanceWithToken().delete<IRoleResource>(`roles/${id}`);

export const deleteRoles = async (data: IBulkDeleteRequest) =>
  axiosInstanceWithToken().post<IRoleResource[]>(`roles/delete`, data);
